import { MuiComponent } from "./type";

export const MuiContainer: MuiComponent<"MuiContainer"> = {
  styleOverrides: {
    root: {
      ['&.MuiContainer-maxWidthXl']: {
        paddingLeft: '8px',
        paddingRight: '8px',

        // Small screens (sm)
        '@media (min-width:600px)': {
          paddingLeft: '16px',
          paddingRight: '16px',
        },

        // Medium screens (md)
        '@media (min-width:900px)': {
          paddingLeft: '24px',
          paddingRight: '24px',
        },

        // Large screens (lg)
        '@media (min-width:1200px)': {
          paddingLeft: '40px',
          paddingRight: '40px',
        },

        // Extra-large screens (xl)
        // '@media (min-width:1536px)': {
        //   paddingLeft: '40px',
        //   paddingRight: '40px',
        // },
      },
    },
  },
};